import { render, staticRenderFns } from "./childInsuranceCompany.vue?vue&type=template&id=7ad50974&scoped=true&"
import script from "./childInsuranceCompany.vue?vue&type=script&lang=js&"
export * from "./childInsuranceCompany.vue?vue&type=script&lang=js&"
import style0 from "./childInsuranceCompany.vue?vue&type=style&index=0&id=7ad50974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad50974",
  null
  
)

export default component.exports